var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"phone-input"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"input"},[_c('input',{attrs:{"pattern":"\\d*","type":"tel","maxlength":"11","placeholder":_vm.placeholder},domProps:{"value":_vm.phone},on:{"keyup":_vm.inputPhone}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }